import { fork } from 'redux-saga/effects';
import discoverCommunitiesSaga from './discoverCommunities';
import userCommunitiesSaga from './usersCommunitiesSaga';
import handleJoinRequestsSaga from './handleJoinRequests';
import joinRequestsPagination from './joinRequestListPagination';
import joinCommunityPopup from './joinCommunityPopup';
import joinRequestNotification from './joinRequestNotification';
import newPost from './newPost';
import newPostComment from './newPostComment';
import removeNotificationsCounters from './removeNotificationsCounters';
import usersJoinRequestsPagination from './usersJoinRequestsPagination';
import leaveCommunity from './leaveCommunity';
import activitiesRootSaga from './activitiesSaga';

export default function* root() {
  yield fork(discoverCommunitiesSaga);
  yield fork(userCommunitiesSaga);
  yield fork(handleJoinRequestsSaga);
  yield fork(joinRequestsPagination);
  yield fork(joinCommunityPopup);
  yield fork(joinRequestNotification);
  yield fork(newPost);
  yield fork(newPostComment);
  yield fork(removeNotificationsCounters);
  yield fork(usersJoinRequestsPagination);
  yield fork(leaveCommunity);
  yield fork(activitiesRootSaga);
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/index.js